import { Injectable, inject } from '@angular/core';
import { BodySchemaData } from '@bepatient/body-schema-store';
import { CoreHttpClient } from '@bepatient/core';
import { Observable, of, OperatorFunction } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class BodySchemaApiService {
  private http = inject(CoreHttpClient);

  loadBodySchema(url: string): Observable<BodySchemaData> {
    const split = url.split('/answers/');
    return this.http
      .get(split[0], { withMobiCredentials: true })
      .pipe(this.bodySchemaParser());
  }

  saveBodySchema(url: string, bodySchemaData: any): Observable<any> {
    const split = url.split('/answers/');

    return (
      split.length === 2
        ? of(url)
        : this.http
            .get<any>(`${url}/answers`, { withMobiCredentials: true })
            .pipe(
              switchMap(data => {
                const todoItem = (data.items || []).find(
                  item => item.status === 'todo'
                );

                return todoItem
                  ? of(
                      (todoItem.links &&
                        todoItem.links.self &&
                        todoItem.links.self.href) ||
                        ''
                    )
                  : this.http
                      .post<{ location: string }>(
                        `${url}/answers`,
                        {},
                        { withMobiCredentials: true }
                      )
                      .pipe(map(res => res.location));
              })
            )
    ).pipe(
      switchMap(location =>
        this.http.put<any>(location, bodySchemaData, {
          withMobiCredentials: true
        })
      )
    );
  }

  private bodySchemaParser(): OperatorFunction<any, BodySchemaData> {
    return map<any, BodySchemaData>(data => ({
      color: (data.meta && data.meta.color) || '',
      useSurfacePain: (data.meta && data.meta.activate_pain_types) || false
    }));
  }
}
